import {isNullOrUndefined} from "@/plugins/object-helpers"

export const filials = {
  state: {
    defaultFilialId: null,
    filialId: null,
    filialList: [],
  },
  mutations: {
    setDefaultFilialId(state, val) {
      state.defaultFilialId = val
    },
    setFilialId(state, val) {
      state.filialId = val
    },
    setFilialList(state, val) {
      state.filialList = val
    },
    clearFilial(state) {
      state.defaultFilialId = null
      state.filialId = null
      state.filialList = []
    }
  },
  getters: {
    defaultFilialId(state) {
      return state.defaultFilialId
    },
    filialId(state) {
      return state.filialId
    },
    filialName(state) {
      //ID выбранного филиала: приоритетно из filialId, если отсутствует - из defaultFilialId
      let val = isNullOrUndefined(state.filialId) ? state.defaultFilialId : state.filialId

      if (isNullOrUndefined(val)) {
        return ''
      }
      const filial = state.filialList.find(it => it.id === val)
      if (filial === undefined) {
        return ''
      }
      return filial.name
    },
    filialList(state) {
      return state.filialList
    },
  }
}